"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readAppActionRefusal = readAppActionRefusal;
/**
 * Reads from the answer of a refused App action what it names: the rejected
 * items of the input, the fields of an input that does not fit and the
 * settings an automation still needs. Exactly
 * these fields reach the page; everything else of the answer stays out.
 *
 * Self-contained on purpose: the App bridge embeds it via
 * `Function.prototype.toString`.
 */
function readAppActionRefusal(data) {
    const refusal = {};
    if (!data || typeof data !== 'object')
        return refusal;
    const answer = data;
    if (Array.isArray(answer.items)) {
        const items = [];
        for (const entry of answer.items) {
            if (!entry || typeof entry !== 'object')
                continue;
            const { inputKey, index, reason, message } = entry;
            if (typeof inputKey !== 'string' ||
                typeof index !== 'number' ||
                !Number.isInteger(index) ||
                index < 0 ||
                typeof reason !== 'string') {
                continue;
            }
            const item = { inputKey, index, reason };
            if (typeof message === 'string')
                item.message = message;
            items.push(item);
        }
        if (items.length > 0)
            refusal.items = items;
    }
    if (Array.isArray(answer.paths)) {
        const paths = answer.paths
            .filter((path) => typeof path === 'string')
            .slice(0, 16);
        if (paths.length > 0)
            refusal.paths = paths;
    }
    if (Array.isArray(answer.missingSettings)) {
        const missingSettings = [];
        for (const entry of answer.missingSettings.slice(0, 32)) {
            if (!entry || typeof entry !== 'object')
                continue;
            const { stepTitle, slotKey, labelsI18n } = entry;
            if (typeof stepTitle !== 'string' || typeof slotKey !== 'string') {
                continue;
            }
            if (!labelsI18n || typeof labelsI18n !== 'object')
                continue;
            const labels = {};
            for (const [locale, label] of Object.entries(labelsI18n)) {
                if (typeof label === 'string')
                    labels[locale] = label;
            }
            // A slot label always has its English entry; without it the entry is
            // no setting of the contract.
            const en = labels.en;
            if (typeof en !== 'string')
                continue;
            missingSettings.push({
                stepTitle,
                slotKey,
                labelsI18n: { ...labels, en },
            });
        }
        if (missingSettings.length > 0)
            refusal.missingSettings = missingSettings;
    }
    return refusal;
}
